import styled from 'styled-components';

import {colors} from 'theme';

export const InnerLink = styled.a`
    color: ${colors.brandPrimary};

    &:hover {
        text-decoration: none;
    }
`;
